import React, { useState } from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { Button, Alert, Spin, Radio } from 'antd';

import { UserOutlined, MailOutlined, LockOutlined } from '@ant-design/icons';
import { Fieldset } from 'components/form';

import { Form, FormItem, Input } from 'formik-antd';
import { Formik } from 'formik';

import { useAuthState } from 'react-firebase-hooks/auth';
import { useDocument } from 'react-firebase-hooks/firestore';

import { useQuery } from 'hooks/utils';
import Client from 'containers/app/client';
import { LayoutPage } from 'components/layouts';

import schema from './schema';
import initialValues from './initial-values';

import './style.css';

const Signup = () => {
  const { id } = useParams();
  const query = useQuery();
  const history = useHistory();
  const inviteId = query.get('invite');

  const { auth } = Client;
  const [user, loading, error] = useAuthState(auth);
  const invitePath = `admin_invites/${inviteId}`;
  const [invite, loadingInvite, errorInvite] = useDocument(
    inviteId && Client.db.doc(invitePath)
  );
  const [waiting, setWaiting] = useState(false);
  const [username, setUsername] = useState(query.get('username'));
  const [email, setEmail] = useState(query.get('email'));
  const [firstname, setFirstname] = useState(query.get('firstname'));
  const [lastname, setLastname] = useState(query.get('lastname'));

  if (loading || loadingInvite) return <Spin />;
  if (error || errorInvite) throw error != null ? error : errorInvite;

  const handleSubmit = async (values, actions) => {
    setWaiting(true);
    try {
      await Client.signup({ inviteId, ...values }, () => {
        history.push('/confirmation-sent');
      });
    } catch (e) {
      setWaiting(false);
      actions.setSubmitting(false);
      actions.setStatus({ message: e.message, type: 'error' });
    }
  };

  const initialValuesWithWithData = {
    ...initialValues,
    role: inviteId != null ? 'isEmployer' : id,
    firstName: inviteId != null ? invite.data().firstName : firstname,
    lastName: inviteId != null ? invite.data().lastName : lastname,
    email: inviteId != null ? invite.data().email : email,
    displayName: inviteId != null ? invite.data().username : username,
  };

  return (
    <LayoutPage className="signup-page">
      <LayoutPage.Container className="wrapper">
        <Formik
          initialValues={initialValuesWithWithData}
          onSubmit={handleSubmit}
          validationSchema={schema}
        >
          {({ isSubmitting, status, setStatus }) => {
            if (user && !isSubmitting) {
              return <Redirect to="/" />;
            }

            return (
              <Form layout="vertical" className="wrapper">
                <Spin
                  spinning={waiting}
                  tip="Checking details, please be patient..."
                >
                  <h1>Sign Up</h1>
                  {status != null ? (
                    <Alert
                      closable
                      message={status.message}
                      type={status.type}
                      onClose={() => {
                        setStatus(undefined);
                      }}
                    />
                  ) : null}
                  <FormItem label="Role" name="role" style={{ display: 'none' }}>
                    <Radio.Group name="role" disabled={inviteId != null}>
                      <Radio.Button value="isWorker">Worker</Radio.Button>
                      <Radio.Button value="isEmployer">Employer</Radio.Button>
                    </Radio.Group>
                  </FormItem>
                  <Fieldset>
                    <FormItem label="Username" name="displayName">
                      <Input
                        name="displayName"
                        placeholder="user123"
                        // value={username}
                        // onChange={(e) => setUsername(e.target.value)}
                        prefix={<UserOutlined />}
                      />
                    </FormItem>
                    <FormItem label="Email" name="email">
                      <Input
                        type="email"
                        name="email"
                        // value={email}
                        // onChange={(e) => setEmail(e.target.value)}
                        prefix={<MailOutlined />}
                        placeholder="e@mail.com"
                        disabled={inviteId != null}
                      />
                    </FormItem>
                  </Fieldset>
                  <Fieldset>
                    <FormItem label="First Name" name="firstName">
                      <Input
                        name="firstName"
                        placeholder="Name"
                        // value={firstname}
                        // onChange={(e) => setFirstname(e.target.value)}
                        prefix={<UserOutlined />}
                      />
                    </FormItem>
                    <FormItem label="Last Name" name="lastName">
                      <Input
                        name="lastName"
                        placeholder="Last name"
                        // value={lastname}
                        // onChange={(e) => setLastname(e.target.value)}
                        prefix={<UserOutlined />}
                      />
                    </FormItem>
                  </Fieldset>
                  <Fieldset>
                    <FormItem label="Password" name="password">
                      <Input
                        type="password"
                        name="password"
                        prefix={<LockOutlined />}
                        placeholder="strong password"
                      />
                    </FormItem>
                    <FormItem label="Confirm password" name="confirm">
                      <Input
                        type="password"
                        name="confirm"
                        prefix={<LockOutlined />}
                        placeholder="strong password"
                      />
                    </FormItem>
                  </Fieldset>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isSubmitting}
                    disabled={isSubmitting}
                  >
                    Register
                  </Button>
                </Spin>
              </Form>
            );
          }}
        </Formik>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

Signup.propTypes = {};

export default Signup;
